exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.top-left[data-v-b8387026] {\n    top: 16px;\n    right: 16px;\n    cursor: pointer;\n}\n\n", ""]);

// exports
